const { DATA_KEY_PATHS } = require("../constants/state")

const getData = (state, keys) => {
    let keyPath = []
    
    if('string' === typeof keys) {
        keyPath = [ ...DATA_KEY_PATHS[keys] ]
    } else {
        const keysLength = keys.length
        keyPath = [ ... DATA_KEY_PATHS[keys[0]] ]


        if(keysLength > 0) {
            for (let i = 1; i < keysLength; i++) {
                const k = 'string' === typeof keys[i] ? keys[i] : keys[i].toString()
                keyPath.push(k)
            }
        }
    }
   
    return state.getIn(keyPath)
}

export default getData
